import React from "react";
import { useWalkthrough } from "../../services/WalkthroughContext";

// Render the current step's background image as a full-bleed <img> inside
// the IntroScreen content area. This avoids changing IntroScreen while
// ensuring GIFs with spaces in their filenames load correctly.
export default function BackgroundOnly() {
  const { currentStep } = useWalkthrough();
  const bg = currentStep?.ui?.backgroundImage;
  if (!bg) return null;

  // encodeURI to safely handle spaces and special characters in filenames
  const src = encodeURI(bg);

  return (
    <img
      src={src}
      alt="background"
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        pointerEvents: "none",
      }}
    />
  );
}
